import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaItaobuyPage from "../pages/guida-itaobuy-spreadsheet-italiano/page";
import ItaobuySicuroPage from "../pages/itaobuy-e-sicuro/page";
import ComeUsarePage from "../pages/come-usare-itaobuy-spreadsheet/page";
import SneakersPage from "../pages/itaobuy-spreadsheet-sneakers/page";
import ModaPage from "../pages/itaobuy-spreadsheet-moda/page";
import SpedizionePage from "../pages/itaobuy-spedizione-italia/page";
import PrezziPage from "../pages/itaobuy-prezzi/page";
import AlternativePage from "../pages/itaobuy-vs-alternative/page";
import QCPhotosPage from "../pages/itaobuy-qc-photos/page";
import RecensioniPage from "../pages/itaobuy-recensioni/page";
import FAQPage from "../pages/faq-itaobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guida-itaobuy-spreadsheet-italiano",
    element: <GuidaItaobuyPage />,
  },
  {
    path: "/itaobuy-e-sicuro",
    element: <ItaobuySicuroPage />,
  },
  {
    path: "/come-usare-itaobuy-spreadsheet",
    element: <ComeUsarePage />,
  },
  {
    path: "/itaobuy-spreadsheet-sneakers",
    element: <SneakersPage />,
  },
  {
    path: "/itaobuy-spreadsheet-moda",
    element: <ModaPage />,
  },
  {
    path: "/itaobuy-spedizione-italia",
    element: <SpedizionePage />,
  },
  {
    path: "/itaobuy-prezzi",
    element: <PrezziPage />,
  },
  {
    path: "/itaobuy-vs-alternative",
    element: <AlternativePage />,
  },
  {
    path: "/itaobuy-qc-photos",
    element: <QCPhotosPage />,
  },
  {
    path: "/itaobuy-recensioni",
    element: <RecensioniPage />,
  },
  {
    path: "/faq-itaobuy",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;